import { Component, OnInit } from '@angular/core';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { ModalService } from '../../../../../services/modal.service';
import { TranslationPipe } from '../../../../../pipes/translation.pipe';

@Component({
    selector: 'app-homework-tip',
    templateUrl: './homework-tip.component.html',
    styleUrls: ['./homework-tip.component.scss'],
    standalone: true,
    imports: [
        TranslationPipe
    ]
})
export class HomeworkTipComponent implements OnInit {

    variableText: string;

    constructor(
        public applicationStateService: ApplicationStateService,
        public modalService: ModalService) {
    }

    ngOnInit(): void {
        this.variableText = this.applicationStateService.userData.isTeacher
            ? 'und schicke Deinen SchülerInnen den Abgabelink'
            : 'und öffne den Abgabelink';
    }

    openDisabledModal(): void {
        this.modalService.openDisabledHSMModal();
    }
}
